import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "@emotion/react";
import { Children, forwardRef } from 'react';
import { Container } from '../../primitives/Stack/components/Container.js';
import { Divider } from '../../primitives/Stack/components/Divider.js';
import { SPACING_MEDIUM } from '../../utils/spacingLegacy.js';
export const Stack = /*#__PURE__*/_styled(forwardRef(({
  spacing = SPACING_MEDIUM,
  divider = false,
  dividerProps = {
    category: 'secondary',
    type: 'solid'
  },
  direction = 'column',
  children,
  ...restProps
}, ref) => {
  const items = Children.toArray(children);
  return _jsx(Container, {
    ...restProps,
    ref: ref,
    spacing: spacing,
    direction: direction,
    children: items.reduce((result, item, index) => {
      if (divider && index < items.length - 1) {
        return result.concat([item, _createElement(Divider, {
          ...dividerProps,
          key: `divider-${index}`,
          direction: direction
        })]);
      }
      return result.concat(item);
    }, [])
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e3r7wp80"
} : {
  target: "e3r7wp80",
  label: "Stack"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0YWNrLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCSSIsImZpbGUiOiJTdGFjay5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgeyBjcmVhdGVFbGVtZW50IGFzIF9jcmVhdGVFbGVtZW50IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBDaGlsZHJlbiwgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvU3RhY2svY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgRGl2aWRlciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvU3RhY2svY29tcG9uZW50cy9EaXZpZGVyLmpzJztcbmltcG9ydCB7IFNQQUNJTkdfTUVESVVNIH0gZnJvbSAnLi4vLi4vdXRpbHMvc3BhY2luZ0xlZ2FjeS5qcyc7XG5leHBvcnQgY29uc3QgU3RhY2sgPSBzdHlsZWQoZm9yd2FyZFJlZigoeyBzcGFjaW5nID0gU1BBQ0lOR19NRURJVU0sIGRpdmlkZXIgPSBmYWxzZSwgZGl2aWRlclByb3BzID0geyBjYXRlZ29yeTogJ3NlY29uZGFyeScsIHR5cGU6ICdzb2xpZCcgfSwgZGlyZWN0aW9uID0gJ2NvbHVtbicsIGNoaWxkcmVuLCAuLi5yZXN0UHJvcHMgfSwgcmVmKSA9PiB7XG4gICAgY29uc3QgaXRlbXMgPSBDaGlsZHJlbi50b0FycmF5KGNoaWxkcmVuKTtcbiAgICByZXR1cm4gKF9qc3goQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgcmVmOiByZWYsIHNwYWNpbmc6IHNwYWNpbmcsIGRpcmVjdGlvbjogZGlyZWN0aW9uLCBjaGlsZHJlbjogaXRlbXMucmVkdWNlKChyZXN1bHQsIGl0ZW0sIGluZGV4KSA9PiB7XG4gICAgICAgICAgICBpZiAoZGl2aWRlciAmJiBpbmRleCA8IGl0ZW1zLmxlbmd0aCAtIDEpIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gcmVzdWx0LmNvbmNhdChbXG4gICAgICAgICAgICAgICAgICAgIGl0ZW0sXG4gICAgICAgICAgICAgICAgICAgIF9jcmVhdGVFbGVtZW50KERpdmlkZXIsIHsgLi4uZGl2aWRlclByb3BzLCBrZXk6IGBkaXZpZGVyLSR7aW5kZXh9YCwgZGlyZWN0aW9uOiBkaXJlY3Rpb24gfSksXG4gICAgICAgICAgICAgICAgXSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICByZXR1cm4gcmVzdWx0LmNvbmNhdChpdGVtKTtcbiAgICAgICAgfSwgW10pIH0pKTtcbn0pKSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN0YWNrLmpzLm1hcCJdfQ== */");